export function setAboutVisibility (value) {
    return {
        type: 'SET_ABOUT_VISIBILITY',
        value
    }
}


// WEBPACK FOOTER //
// ./src/actions/sections/AboutActions.js